import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Combattente** (manuale V1, rr. 1372-1379).
 *
 * Maneggia un'arma decentemente, supporta il PG in attacchi mischia/distanza.
 *
 * **Pattern «sostituisce»**: il Rango 2 sostituisce il Rango 1. Quando il
 * Combattente raggiunge R2, perde l'effetto di R1 (manuale r. 1377).
 */
export const combattente: FollowerAbility = {
  id: 'combattente',
  label: 'Combattente',
  description:
    "Di certo non è un maestro, ma riesce a maneggiare un'arma abbastanza bene da non decapitarsi per sbaglio. Forse potrà anche darti una mano in combattimento. Possibile.",
  ranks: [
    {
      rank: 1,
      trigger: 'Quando un Combattente ti *aiuta* a fare *taglia e spacca* o una *raffica*',
      description: 'Se infliggi danno, infliggi +1 danno.',
    },
    {
      rank: 2,
      trigger: 'Quando un Combattente ti *aiuta* a fare *taglia e spacca* o una *raffica*',
      description: 'Se infliggi danno, infliggi +1d4 danni.',
      replacesRank: 1,
    },
    {
      rank: 3,
      trigger: 'Quando un Combattente ti *aiuta* a fare *taglia e spacca* o una *raffica*',
      description:
        'Prendi +1 al tiro. Con un 7-9 o un fallimento, anche il gregario si mette in difficoltà o deve pagare un prezzo.',
    },
  ],
};
